/* Digitizing Craft — Grid Studio interactions. Vanilla, ~2KB, no dependencies.
   Nothing here blocks first paint: the page is fully usable without it. */
(function () {
  'use strict';
  var d = document;
  var root = d.documentElement;
  var cfg = window.dcStudio || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* 1. Reveal on scroll — elements already on screen are never hidden */
  function initReveal() {
    var els = d.querySelectorAll('[data-dc-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    root.classList.add('dc-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    var vh = window.innerHeight;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* 2. Cursor guides: snap to the grid like a design tool (desktop only) */
  function initCursor() {
    var layer = d.querySelector('.dc-cursor');
    if (!layer || reduce || !finePointer || cfg.cursor === false) return;
    var x = layer.querySelector('.dc-cursor__x');
    var y = layer.querySelector('.dc-cursor__y');
    var cell = layer.querySelector('.dc-cursor__cell');
    var label = layer.querySelector('.dc-cursor__label');
    var px = 0, py = 0, ticking = false;
    function grid() { return parseFloat(getComputedStyle(root).getPropertyValue('--dc-grid')) || 28; }
    var g = grid();
    function draw() {
      ticking = false;
      var sx = Math.floor(px / g) * g, sy = Math.floor(py / g) * g;
      x.style.transform = 'translate3d(0,' + sy + 'px,0)';
      y.style.transform = 'translate3d(' + sx + 'px,0,0)';
      cell.style.transform = 'translate3d(' + sx + 'px,' + sy + 'px,0)';
      if (label) {
        label.style.transform = 'translate3d(' + (sx + g + 6) + 'px,' + (sy + g + 6) + 'px,0)';
        label.textContent = 'X ' + String(Math.round(sx / g)).padStart(2, '0') + ' · Y ' + String(Math.round(sy / g)).padStart(2, '0');
      }
    }
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      px = e.clientX; py = e.clientY;
      if (!root.classList.contains('dc-cursor-on')) root.classList.add('dc-cursor-on');
      if (!ticking) { ticking = true; requestAnimationFrame(draw); }
    }, { passive: true });
    d.addEventListener('pointerleave', function () { root.classList.remove('dc-cursor-on'); });
    window.addEventListener('resize', function () { g = grid(); }, { passive: true });
  }

  /* 3. Gentle depth: hero objects drift at different speeds while in view */
  function initDepth() {
    if (reduce || cfg.parallax === false) return;
    var scenes = d.querySelectorAll('[data-dc-scene]');
    if (!scenes.length || !('IntersectionObserver' in window)) return;
    var active = new Set();
    var ticking = false;
    function update() {
      ticking = false;
      active.forEach(function (scene) {
        var r = scene.getBoundingClientRect();
        var progress = -r.top;
        scene.querySelectorAll('[data-dc-depth]').forEach(function (el) {
          var depth = parseFloat(el.getAttribute('data-dc-depth')) || 0;
          el.style.setProperty('--dc-py', (progress * depth).toFixed(1) + 'px');
        });
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? active.add(e.target) : active.delete(e.target); });
    });
    scenes.forEach(function (s) { io.observe(s); });
    window.addEventListener('scroll', function () {
      if (!ticking && active.size) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  function init() { initReveal(); initCursor(); initDepth(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor: re-run reveal when sections are added or re-rendered */
  d.addEventListener('shopify:section:load', function () { initReveal(); });
})();